import { z } from "zod";
const AttachmentType = {
  Resume: "resume",
  TrainingMaterial: "training_material",
  Email: "email",
  ChatPhoto: "chat_photo",
  KnowledgeBaseDocument: "knowledge_base_document"
};
const allAttachmentTypes = [
  AttachmentType.Resume,
  AttachmentType.TrainingMaterial,
  AttachmentType.Email,
  AttachmentType.ChatPhoto,
  AttachmentType.KnowledgeBaseDocument
];
const attachmentTypeSchema = z.enum(allAttachmentTypes);
function isAttachmentType(value) {
  return allAttachmentTypes.includes(value);
}
const attachmentResourceTypes = [
  "contact",
  "company",
  "recording",
  "chat"
];
function isFileAttachmentMetadata(metadata) {
  return Boolean(
    metadata && ("text" in metadata || "body" in metadata || "type" in metadata || "file_name" in metadata)
  );
}
function maybeGetFileAttachmentMetadata(metadata) {
  return isFileAttachmentMetadata(metadata) ? metadata : null;
}
function isRecordingEmailAttachmentMetadata(metadata) {
  return Boolean(metadata && "email" in metadata);
}
function maybeGetRecordingEmailAttachmentMetadata(metadata) {
  return isRecordingEmailAttachmentMetadata(metadata) ? metadata : null;
}
function isKnowledgeBaseDocumentAttachmentMetadata(metadata) {
  return Boolean(
    metadata && "title" in metadata && "description" in metadata && "body" in metadata
  );
}
function maybeGetKnowledgeBaseDocumentAttachmentMetadata(metadata) {
  return isKnowledgeBaseDocumentAttachmentMetadata(metadata) ? metadata : null;
}
const allowedResumeMimeTypes = [
  "application/pdf",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "text/plain",
  "application/rtf",
  "text/rtf"
];
const allowedResumeMimeTypeSchema = z.enum(allowedResumeMimeTypes);
function isAllowedResumeMimeType(value) {
  return allowedResumeMimeTypes.includes(value);
}
function mapAttachmentDBToAttachment(data) {
  return {
    id: data.id,
    type: data.type,
    company_id: data.company_id,
    created_at: data.created_at,
    file_path: data.file_path,
    resource_id: data.resource_id,
    resource_type: data.resource_type,
    metadata: mapAttachmentMetadataDbToAttachmentMetadata(data.metadata)
  };
}
const mapAttachmentMetadataDbToAttachmentMetadata = (data) => {
  return data || {
    text: null,
    body: null,
    type: null,
    file_name: void 0,
    email: null
  };
};
const attachmentToAttachmentPublic = (file) => {
  return {
    id: file.id,
    type: file.type,
    file_path: file.file_path
  };
};
function getAttachmentDisplayName(attachment) {
  const attachmentMetadata = maybeGetFileAttachmentMetadata(
    attachment.metadata
  );
  return attachmentMetadata?.file_name || "Untitled document";
}
export {
  AttachmentType,
  allowedResumeMimeTypeSchema,
  allowedResumeMimeTypes,
  attachmentToAttachmentPublic,
  attachmentTypeSchema,
  getAttachmentDisplayName,
  isAllowedResumeMimeType,
  isAttachmentType,
  isKnowledgeBaseDocumentAttachmentMetadata,
  mapAttachmentDBToAttachment,
  maybeGetFileAttachmentMetadata,
  maybeGetKnowledgeBaseDocumentAttachmentMetadata,
  maybeGetRecordingEmailAttachmentMetadata
};
//# sourceMappingURL=attachment.js.map
